import ReturnsView from './ReturnsView';

import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import {
  returnsActions,
  eligibleDataSel,
  statusDataSel,
  eligibleCoreDataSel,
  partsToReturnSel
} from 'src/store/modules/returns';
import {
  IEligibleFilter,
  IStatusFilter,
  IEligibleItem
} from 'src/services/returns/typings';
import { userActions, userDataSel } from 'src/store/modules/user';

const mapStateToProps = (state: IInitialState) => ({
  eligibleData: eligibleDataSel(state),
  eligibleCoreData: eligibleCoreDataSel(state),
  statusData: statusDataSel(state),
  partsToReturn: partsToReturnSel(state),
  userData: userDataSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getEligibleItems: (body?: IEligibleFilter, queryParams?: string) => {
    dispatch(returnsActions.getEligibleItems(body, queryParams));
  },

  getEligibleCoreItems: (body?: IEligibleFilter, queryParams?: string) => {
    dispatch(returnsActions.getEligibleCoreItems(body, queryParams));
  },

  getStatusItems: (body?: IStatusFilter, queryParams?: string) => {
    dispatch(returnsActions.getStatusItems(body, queryParams));
  },

  clearPartsToReturn: () => {
    dispatch(returnsActions.setPartsToReturn([]));
    dispatch(
      returnsActions.setReturnAlert({
        show: false,
        message: '',
        type: '',
        icon: ''
      })
    );
  },

  onDeleteRmaList: (rmaNumber: string, callback: () => void) => {
    dispatch(returnsActions.onDeleteRMAList(rmaNumber, callback));
  },

  getRMALists: (body?: IStatusFilter) => {
    dispatch(returnsActions.getRMALists(body));
  },

  onLoad: () => {
    dispatch(userActions.getUserDetails());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnsView);
